import InitialState from '../../redux/initial-state';
import { Http } from '../http';
import axiosInstance from './axios-instance';
/* eslint-disable no-useless-escape */

export default {
  getContentServiceContent: function (publicationId, componentId, templateId) {
    let contentServicePayload = {
      publicationId: publicationId,
      components: [{
        componentId: componentId,
        templateId: templateId
      }]
    };
    let endpoint = `${window.location.origin}/api/content/`;

    const { isMockWrapper } = InitialState.getState().appConfig;
    if (isMockWrapper) {
      endpoint = 'https://mirage-888poker.images4us.com/api/Content/';
      contentServicePayload = {
        publicationid: 1240,
        components: [{
          componentId: 84293,
          templateid: 84294
        }]
      };
    }

    // const mockResponseImg = [{"ComponentId":84293,"TemplateId":84294,"Content":`<!--<div>\r\n\r\n\r\n\r\n<img src=\"https://sportclient-qa.888sport.com/assets/img/banner.png\" alt=\"Trulli\" width=\"0\" height=\"0\"/>\r\n\r\n\r\n\r\n</div>-->`}];
    // const mockResponseJustScripts = [{"ComponentId":84293,"TemplateId":84294,"Content":`<div><script></script></div>`}];

    return new Http(axiosInstance.get()).post({},endpoint, contentServicePayload)
      .then(res => res.data);
    // .then(() => mockResponseJustScripts);
  }
};
